package com.yet.tetris.feature.history.store

import com.arkivanov.mvikotlin.core.store.Store
import com.yet.tetris.domain.model.history.GameRecord
import com.yet.tetris.domain.model.progression.ProgressionSummary
import com.yet.tetris.feature.history.DateFilter
import com.yet.tetris.feature.history.utils.applyHistoryDateFilter
import kotlin.time.ExperimentalTime

internal interface HistoryStore : Store<HistoryStore.Intent, HistoryStore.State, HistoryStore.Label> {
    data class State(
        val games: List<GameRecord> = emptyList(),
        val dateFilter: DateFilter = DateFilter.ALL,
        val progression: ProgressionSummary = ProgressionSummary.EMPTY,
        val isLoading: Boolean = true,
    ) {
        @OptIn(ExperimentalTime::class)
        val filteredGames: List<GameRecord>
            get() = applyHistoryDateFilter(games = games, filter = dateFilter)
    }

    sealed class Intent {
        data object Refresh : Intent()

        data class FilterByDate(
            val filter: DateFilter,
        ) : Intent()

        data class DeleteGame(
            val id: String,
        ) : Intent()
    }

    sealed class Msg {
        data class GamesLoaded(
            val games: List<GameRecord>,
            val progression: ProgressionSummary,
        ) : Msg()

        data class FilterChanged(
            val filter: DateFilter,
        ) : Msg()

        data class LoadingChanged(
            val isLoading: Boolean,
        ) : Msg()
    }

    sealed class Action {
        data object HistoryLoadStarted : Action()
    }

    sealed class Label {
        data class ShowError(
            val message: String,
        ) : Label()

        data class GameDeleted(
            val id: String,
        ) : Label()
    }
}
